import { colors } from '@mdd/elements/mdd-styles/colors';
import { CardConfigRaw } from './config';

const { lines } = colors.chart.weights.with(2).lines;

export const compareModeConfigRaw: CardConfigRaw = {
    ids: [],
    series: [
        {
            name: '(current)',
            id: 'id_current',
            type: 'spline',
            color: colors.milking,
            visible: true,
            mdd: {}
        },
        {
            name: '(past)',
            id: 'id_past',
            type: 'spline',
            color: colors.warningLight,
            mdd: {}
        }
    ],
    yAxis: [
        {
            title: { text: '' }
        },
        {
            title: { text: '' },
            opposite: true
        },
        {
            title: { text: '' },
            softMin: 40
        }
    ]
};
